import createEmotion from '@emotion/css/create-instance';

export default (options: {
  headerColor?: string;
  fontColor?: string;
  headerLighterColor?: string;
  headerDarkerColor?: string;
  gradientColor?: string;
} = {}) => {
  const bgColor = 'rgba(255, 255, 255)';
  const headerColor = options.headerColor || '#3361FF';
  const fontColor = options.fontColor;
  const headerLighterColor = options.headerLighterColor || '#8590f1';
  const headerDarkerColor = options.headerDarkerColor || '#2347c2';
  const gradientColor = options.gradientColor;

  // eslint-disable-next-line
  const { css } = createEmotion({
    container: window.talkvisorWidget,
    key: 'tv',
  });

  return {
    headerColor: headerColor,
    headerDarkerColor: headerDarkerColor,
    positioner: css`
      color: #333232;
      font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
      font-size: 16px;
      letter-spacing: normal;
      line-height: 18.4px;
      position: fixed;
      bottom: 12px;
      margin: 0 20px 20px 0;
      border-radius: 8px;
      z-index: 2147483647;
      pointer-events: none;
      height: 100%;
    `,
    chatContainer: css`
      overflow: visible;
      background: ${bgColor};
      border-radius: 20px;
      height: 650px;
      max-height: calc(100% - 150px);
      min-height: 208px;
      font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
      border: 2px solid ${headerColor};
      margin-bottom: 68px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: -8px;
      width: 375px;
      max-width: 90vw;
      box-shadow: 0px 5px 24px 0px rgba(0, 0, 0, 0.16);
    `,
    chatContainerGradient: css`
      background: ${bgColor};
      border-radius: 20px;
      height: 650px;
      max-height: calc(100% - 150px);
      min-height: 208px;
      font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
      margin-bottom: 68px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: -8px;
      width: 375px;
      max-width: 90vw;
      box-shadow: 0px 5px 24px 0px rgba(0, 0, 0, 0.16);
      border: solid 2px transparent;
      box-sizing: border-box;
      z-index: 0;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        margin: -2px;
        border-radius: 22px;
        background: linear-gradient(
          to left top,
          ${headerColor},
          ${gradientColor}
        );
      }
    `,
    chatPane: css`
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      color: #0f0f0f;
      padding: 14px 23px 14px 23px;
      background: white;
      overflow-y: auto;
      overflow-x: hidden;
      box-shadow: inset 0 1px 0 rgba(0,0,0,0.1);
      pointer-events: all;

      &::-webkit-scrollbar-track
      {
        box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        background-color: ${bgColor};
      }

      &::-webkit-scrollbar
      {
        width: 10px;
        background-color: #d5d5d5;
      }

      &::-webkit-scrollbar-thumb
      {
        background-color: #d5d5d5;
        border: 2px solid #d5d5d5;
      }

      div:first-child {
        margin-top: auto;
      }

      &:empty {
        display: flex !important;
      }
    `,
    inputToolsWrapper: css`
      padding-top: 3px;
      cursor: pointer;
      pointer-events: all;
    `,
    input: css`
      flex-grow: 1;
      display: block !important;
      height: max-content;
      padding: 5px 13px;
      background: rgba(255, 255, 255, 0.9);
      width: calc(100% - 62px);
      min-height: 50px;
      pointer-events: all;
      outline: none;
      font-size: 16px;
      font-weight: 400;
      border: none;
      font-family: Inter;
      color: #0f0f0f;
      resize: none;
      box-shadow: none !important;

      &:empty:not(:focus):before{
        content: 'Send a message';
        color: grey;
      }
    `,
    chatHeaderGradient: css`
      font-size: 16px;
      padding: 25px 25px;
      text-align: center;
      position: relative;
      background: ${headerLighterColor};
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2px;
      border-radius: 20px 20px 0 0;
    `,
    chatHeader: css`
      font-size: 16px;
      padding: 25px 25px;
      text-align: center;
      position: relative;
      background: ${headerLighterColor};
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid ${headerColor};
      border-radius: 20px 20px 0 0;
    `,
    leftChatHeader: css`
      display: flex;
      align-items: center;
    `,
    backChevron: css`
      background: none;
      border: none;
      padding: 0 25px 0 0;
    `,
    divider: css`
      display: block !important;
      border-bottom: 1px solid ${headerColor};
    `,
    minimizeButton: css`
      padding: 3px 10px 17px 0;
      border: 0;
      cursor: pointer;
      border-radius: 1px;
      pointer-events: all;
      background: transparent;

      &:hover {
        filter: brightness(0.75);
        border-radius: 4px;
      }
    `,
    hidden: css`
      visibility: hidden;
    `,
    chatIcon: css`
      cursor: pointer;
      pointer-events: all;
      position: absolute;
      width: 65px;
      height: 65px;
      bottom: -15px;
      right: 5px;

      &:hover {
        transition: transform .3s ease;
        transform: scale(1.1);
      }
    `,
    agentAnnouncementWrapper: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
    `,
    agentAnnouncementSubText: css`
      margin-top: 24px !important;
      color: #A1A1A1;
      font-family: Inter;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    `,
    agentAnnouncement: css`
      padding: 16px 0;
      color: #000;
      font-family: Inter;
      font-size: 13px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    `,
    agentAnnouncementThumbnail: css`
      width: 64px;
      height: 64px;
      border-radius: 32px;
      object-fit: cover;
      margin-top: 15px;
    `,
    chatThumbnail: css`
      display: inline;
      width: 24px;
      height: 24px;
      border-radius: 12px;
      margin: 3px 4px 0 0;
      object-fit: cover;
    `,
    chatBubbleRow: css`
      display: flex;
      align-items: flex-start;
    `,
    chatBubbleAgent: css`
      border-radius: 20px 20px 20px 0;
      background-color: #F5F5F5;
      line-height: 120%;
      width: max-content;
      height: max-content;
      max-width: 250px;
      padding: 12px 13px 12px 12px;
      word-break: break-word;
      white-space: pre-line;
      margin-left: 7px;
    `,
    chatBubbleMe: css`
      line-height: 120%;
      border-radius: 20px 20px 0 20px;
      background-color: ${headerColor};
      width: max-content;
      height: max-content;
      max-width: 294px;
      padding: 8px 12px;
      word-break: break-word;

      a {
        color: #fff;
        text-decoration: underline;
      }
    `,
    choicesWrapper: css`
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
    `,
    chatBubbleChoice: css`
      display: inline-block;
      background-color: ${headerColor};
      color: ${fontColor};
      width: max-content;
      height: max-content;
      max-width: 100%;
      padding: 6px;
      margin-right: 10px;
      margin-top: 10px;
      word-break: break-word;
      cursor: pointer;
      border-radius: 4px;
      transition: filter 0.3s;

      &:hover {
        transition: filter 0.3s;
        filter: brightness(0.85);
      }
    `,
    chatBubbleChoiceSelected: css`
      background-color: ${headerColor};
      color: ${fontColor};
      width: max-content;
      height: max-content;
      max-width: 100%;
      padding: 6px;
      margin-top: 10px;
      word-break: break-word;
      border-radius: 4px;
    `,
    chatBubbleInfo: css`
    `,
    agentName: css`
      color: rgb(122, 122, 122);
      font-size: 11px;
      height: 16px;
      padding-bottom: 6px;
    `,
    agentSentTime: css`
      font-weight: 500;
      margin-left: 37px;
      font-family: Inter;
      margin-top: 5px;
      color: #ADB8CC;
      font-size: 14px;
      font-style: italic;
    `,
    chatBubbleTime: css`
      color: #7a7a7a;
      font-size: 10px;
      margin: 0 0 10px 5px;
      min-width: 83px;
    `,
    flexEnd: css`
      display: flex;
      justify-content: flex-end;
    `,
    actionMessage: css`
      border-radius: 10px;
      background-color: #f5f5f5;
      width: max-content;
      height: max-content;
      max-width: calc(100% - 20px);
      padding: 8px 12px;
      word-break: break-word;
      margin-top: 10px;
      font-style: italic;
      line-height: 120%;
      margin-top: 10px;
    `,
    previewBubbleContainer: css`
      position: absolute;
      bottom: 50px;
      max-width: 300px;
      width: max-content;
      margin-right: 10px;
    `,
    chatBubblePreview: css`
      color: ${fontColor};
      background-color: ${headerColor};
      word-break: break-word;
      margin-bottom: 10px;
      border-radius: 20px 20px 20px 0;
      padding: 12px 13px 12px 12px;
    `,
    previewBubbleProduct: css`
      cursor: pointer;
      pointer-events: all;
      text-decoration: none;
    `,
    chatEmailForm: css`
      display: flex;
      justify-content: center;
      margin: 9px 0;

      button {
        background-color: ${headerColor};
        border: 0px;
        color: ${fontColor};
      }

      input {
        border-radius: 4px 0 0 4px;
        border: 1px solid #c1c1c1;
        outline: none;
        padding: 10px;
        box-shadow: none;
      }

      input:focus-visible {
        border-radius: 4px 0 0 4px;
        border: 1px solid #3361FF;
        outline: none;
        padding: 10px;
        box-shadow: none;
        border: 1px solid ${headerColor};
      }
    `,
    sendBtn: css`
      height: 43px;
      width: 43px;
      min-height: 43px;
      min-width: 43px;
      border-radius: 43px;
      background: ${headerColor};
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      pointer-events: all;

      &:hover {
        background: ${headerDarkerColor};
      }
    `,
    inputWrapper: css`
      display: flex;
      align-items: center;
      padding: 10px 18px 11px 18px;
      margin-top: 1px;
    `,
    chatFooter: css`
      background: white;
      border-radius: 0 0 20px 20px;
    `,
    variableTextColor: css`
      color: ${fontColor};
    `,
    agentGroup: css`
      display: flex;
      margin-right: 15px;
    `,
    onlineDot: css`
      background: #7fd47f;
      font-size: 10px;
      position: relative;
      top: -7px;
      left: -6px;
      width: 13px;
      height: 13px;
      border-radius: 13px;
      border: 0.5px solid white;
    `,
    offlineDot: css`
      background: red;
      font-size: 10px;
      position: relative;
      top: -7px;
      left: -6px;
      width: 13px;
      height: 13px;
      border-radius: 13px;
      border: 0.5px solid white;
    `,
    agentThumbnail: css`
      width: 30px;
      height: 30px;
      border-radius: 30px;
      object-fit: cover;
      margin-right: 15px;

      &:last-of-type {
        margin-left: -68px;
        margin-top: -1px;
        width: 33px;
        width: 33px;
      }
    `,
    agentThumbnailTwo: css`
      width: 30px;
      height: 30px;
      border-radius: 30px;
      object-fit: cover;
      margin-right: -10px;
    `,
    agentThumbnailOne: css`
      width: 30px;
      height: 30px;
      border-radius: 30px;
      object-fit: cover;
    `,
    headerMessage: css`
    `,
    returnTime: css`
      text-align: left;
      color: rgba(0, 0, 0, 0.50);
      font-family: Inter;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    `,
    headerTitle: css`
      color: ##0F0F0F;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: left;
    `,
    orderPreviewWrapper: css`
      display: inline-block;
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 14px 14px 10px 14px;
      width: 90%;
      margin-top: 10px;
      text-decoration: none;
    `,
    orderPreviewName: css`
      color: #192A3E;
      font-weight: 600;
      vertical-align: super;
    `,
    orderByline: css`
      padding-top: 4px;
      font-size: 14px;
      color: #4c5862;
    `,
    interpunct: css`
      padding: 0 3px;
    `,
    orderPreviewDivider: css`
      border-top: 1px solid #e4eaff;
      width: 100%;
      height: 0;
      margin: 10px 0 12px 0;
    `,
    orderPreviewLineItem: css`
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    `,
    lineItemLeft: css`
      position: relative;
    `,
    lineItemImage: css`
      width: 50px;
      height: 50px;
      border-radius: 4px;
      object-fit: contain;
    `,
    lineItemQuantity: css`
      background: #727272e6;
      height: 16px;
      width: 16px;
      border-radius: 16px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -4px;
      left: 40px;

    `,
    lineItemName: css`
      color: #192A3E;
      font-size: 14px;
      font-weight: 600;
      padding-left: 10px;
    `,
    lineItemRefund: css`
      padding-left: 10px;
    `,
    chatEmail: css`
      border-radius: 0 4px 4px 0;
    `,
    noMessages: css`
      text-align: center;
      color: #a1a1a1;
      margin-bottom: 20px;
    `,
    poweredBy: css`
      color: rgba(0, 0, 0, 0.50);
      font-size: 13px;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 12px;

      svg {
        margin: 0 3px 0 6px;
      }
    `,
    emoticonWrapper: css`
      position: relative;
      pointer-events: all;

      >em-emoji-picker {
        position: absolute;
        left: -50px;
        top: -458px;
      }
    `,
    bottomSpacer: css`
      height: 14px;
    `,
    widgetIcon: css`
      width: 60px;
      height: 60px;
      border-radius: 60px;
      object-fit: cover;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);
    `,
    // Copied from `components/Conversation/ProductResponse`
    productResponse: css`
      .row {
        margin-right: 9px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .product-card {
        cursor: pointer;
        width: 280px;
        border-radius: 10px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12);
        background-color: #fff;
      }

      .product-img {
        width: 100%;
        height: 213px;
        object-fit: cover;
        border-radius: 10px 10px 0 0;
      }

      .product-info {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        padding: 18px 15px;
        overflow: hidden;
        color: #000;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        line-height: normal;
        font-weight: 400;
      }

      .product-title {
        font-weight: 600;
        text-overflow: ellipsis;
        width: calc(100% - 30px);
        overflow: hidden;
      }

      .product-option {
        font-size: 13px;
      }

      .addl-count {
        font-size: 13px;
      }
    `,
    messageInnerWrapper: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,
    attachmentIcon: css`
      height: 22px;
      width; 11px;
      padding-right: 12px;
      cursor: pointer;
      pointer-events: all;

      svg {
        cursor: pointer;
      }
    `,
    hiddenInput: css`
      display: none;
    `,
    attachmentObject: css`
      flex-grow: 1;
      margin: 2px 20px 2px 9px;
      padding: 16px 13px;
      border: 1px solid #c1c1c1;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        gap: 10px;
        max-width: 220px;
        word-break: break-all;
        padding-right: 10px;
      }
    `,
    attachmentImage: css`
      width: auto;
      max-width: 280px;
      border-radius: 10px;
    `,
    faqItemsWrapper: css`
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 14px;
    `,
    faqItem: css`
      border-radius: 20px;
      border: 2px solid ${headerColor};
      color: ${headerColor};
      background-color: ${headerLighterColor};
      font-weight: 600;
      line-height: 120%;
      height: max-content;
      width: fit-content;
      padding: 12px;
      word-break: break-word;
      white-space: pre-line;
      font-size: 14px;
      cursor: pointer;
    `,
    spacer: css`
      padding-top: 10px;
    `,
    typingSpacer: css`
      padding-top: 30px;
      padding-left: 30px;
    `,
    dotFlashing: css`
      @keyframes dot-flashing {
        0% {
          background-color: #1e5efe;
        }
        50%,
        100% {
          background-color: rgba(122, 81, 255, 0.2);
        }
      }

      position: relative;
      left: -14px;
      width: 8px;
      height: 8px;
      border-radius: 5px;
      background-color: #1e5efe;
      color: #1e5efe;
      animation: dot-flashing 1s infinite linear alternate;
      animation-delay: 0.5s;

      &:before, &:after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
      }

      &:before {
        left: -13px;
        width: 8px;
        height: 8px;
        border-radius: 5px;
        background-color: #1e5efe;
        color: #1e5efe;
        animation: dot-flashing 1s infinite alternate;
        animation-delay: 0s;
      }

      &:after {
        left: 13px;
        width: 8px;
        height: 8px;
        border-radius: 5px;
        background-color: #1e5efe;
        color: #1e5efe;
        animation: dot-flashing 1s infinite alternate;
        animation-delay: 1s;
      }
    `,
  };
};
